<template>
<div class="component-index default-content-container" 
v-bind:class="{ landscape: isLandscape, 'portrait': isPortrait, mobile : isMobile  }"
    >

    <h1 class="page-title">Henning Maier-Jantzen <em>{{pageTitle}}</em></h1>  

    <div class="page-content">

        <div class="row">
            <div class="columns large-8 text-column">
                <div class="margin-bottom-large" v-for="(category, index) in clients">
                    <h3>{{category.name[lang]}}</h3>
                    
                    <p>
                        <span v-for="(c, cindex) in category.clients">
                            <span v-if="(!c.link || c.nolink) && !c.url ">{{c.name}}</span>
                              <a v-if="c.link && !c.nolink" v-bind:class="{ bold : c.link }" @click="openLink(c)">{{c.name}}</a>
                              <a v-if="c.url && !c.link" :href="c.url" class="bold" target="_blank">{{ c.name }}</a>
                            <span v-if="cindex < category.clients.length -1">, </span>
                        </span>
                    </p>
                </div>
               
            </div>
        </div>
        

    </div>
</div>
</template>

<script>
import store from './store/store';
export default {

    data() {
        return {
            clients : []
        }
    },

    computed : {

        lang()                      { return store.state.language },
        nav()                       { return store.state.navItems },
        clientCategories()          { return store.state.clients },
        snippets()                  { return store.state.textVariables; },
        sidebarStatus()             { return store.state.sidebar.status; },
        windowHeight()              { return store.state.layout.height; },
        windowWidth()               { return store.state.layout.width; },
        domElements()               { return store.state.domElements; },
        projects()                  { return store.state.projects},
        projectsCurrentIndex()      { return store.state.projectsCurrentIndex; },
        projectsCurrentId()         { return store.state.projectsCurrentId; },
        windowRatio()               { return store.getters.getLayoutRatio },
        windowMargin()              { return store.getters.getWindowMargin},
        windowHeight()              { return store.state.layout.height; },
        windowWidth()               { return store.state.layout.width; },
        layout()                    { return store.state.layout; },
        isMobile()                  { if (store.state.layout.type != 'large') { return true; } return false; },
        isLandscape()               { if( this.isMobile && this.layout.orientation == 'landscape' ) { return true } return false; },
        isPortrait()                { if( this.isMobile && this.layout.orientation == 'portrait' ) { return true } return false; },
        slug() { return this.$route.params.pageslug; },
        pageTitle() {
                 return this.nav.clients[this.lang]; 
        }

    },
    
    created : function() {

        this.clients = [];

        if(this.sidebarStatus < 2 && this.layout.type == 'large') {

            store.commit('setSidebar', 1);

        }

        if(this.layout.type != 'large') {
            store.commit('setSidebar', 0);
        }

        console.info("Render clients");
        this.renderCategories();

    },


    methods : {
        
        renderCategories : function() {
            for(var i = 0; i < this.clientCategories.length; i++) {

                this.clients.push( this.renderCategory(this.clientCategories[i]) );
            }
        },

        renderCategory : function(category) {
            
            var cat = false;
            cat = category ;

            for(var i = 0; i < cat.clients.length; i++) {
                
                this.renderClient( cat.clients[i] );
            }

            return cat;
        },

        renderClient : function(client) {

            client.link = false;
            client.projects = this.getClientProjects(client.slug);

            if(client.projects.length > 0) {
                client.link = true;
            }

            // console.log('render client ' + client.slug + " " + client.projects.length);

        },

        getClientProjects : function(clientSlug) {

            var projects = [];

            
            for(var i = 0; i < this.projects.length; i++) {
                  if(this.projects[i].clientSlug == clientSlug) {
                        projects.push( this.projects[i] );
                  }

            }

            return projects
        },

        openLink : function(client) {

            if(client.projects.length == 1) {

                this.$router.push({name : 'project', params : { slug : client.projects[0].id }})

                } else {

                this.$router.push({name : 'index-client', params : { clientSlug : client.slug }})
            }



        }

    }

}
</script>




// WEBPACK FOOTER //
// clients.vue?b89a9b96